/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Scope_Point_4Inputs */

const en_svc_integration_scope_point_4 = /** @type {(inputs: Svc_Integration_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI features added to your own application through an API`)
};

const lv_svc_integration_scope_point_4 = /** @type {(inputs: Svc_Integration_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI funkcijas Jūsu pašu lietotnē caur API`)
};

/**
* | output |
* | --- |
* | "AI features added to your own application through an API" |
*
* @param {Svc_Integration_Scope_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_scope_point_4 = /** @type {((inputs?: Svc_Integration_Scope_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Scope_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_scope_point_4(inputs)
	return en_svc_integration_scope_point_4(inputs)
});